if (!customElements.get('cro-testimonial-rail')) {
  customElements.define(
    'cro-testimonial-rail',
    class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.cro-twall__rail');
        this.querySelector('.cro-twall__arrow--prev')?.addEventListener('click', () => this.slide(-1));
        this.querySelector('.cro-twall__arrow--next')?.addEventListener('click', () => this.slide(1));
        ['pointerenter', 'focusin', 'touchstart'].forEach((t) => this.addEventListener(t, () => this.stop(), { passive: true }));
        ['pointerleave', 'focusout'].forEach((t) => this.addEventListener(t, () => this.start()));
        document.addEventListener('visibilitychange', () => (document.hidden ? this.stop() : this.start()));
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      start() {
        if (this.timer || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.timer = setInterval(() => {
          if (matchMedia('(min-width: 768px)').matches) this.slide(1);
        }, 5000);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      slide(dir) {
        const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        if (max <= 4) return;
        if (dir > 0 && this.rail.scrollLeft >= max - 4) {
          this.rail.scrollTo({ left: 0, behavior });
        } else if (dir < 0 && this.rail.scrollLeft <= 4) {
          this.rail.scrollTo({ left: max, behavior });
        } else {
          this.rail.scrollBy({ left: dir * this.rail.clientWidth, behavior });
        }
      }
    }
  );
}
